import { useRef, useState, useEffect } from "react";
import { IoSparkles } from "react-icons/io5";
import SkillBadge from "../../../common/skillBadge";
import InlineEditableField from "../InlineEditableField";
import useDropdownData from "../../candidateProfiler/profilerEditingPage/useDropDownData";
import JobApplicantsTable from "./jobApplicants";
import {
  formatPostedOnDate,
  preprocessMarkdown,
} from "../../../common/helpers";
import DOMPurify from "dompurify";
import OtherJobsSidebar from "./otherJobsSideBar";
import Loader from "../../../common/loader";
import { marked } from "marked";
import { RecruiterApi } from "../../../supports/recruiterApi";
import { generateRequestId } from "../../../common/common";
import { AlertTriangle, PencilLine, Save, Plus,SendHorizontal,Check,X,Undo2,Undo, RotateCcw } from "lucide-react";
import unifiedAuthManager from "../../../services/unifiedAuthManager";
import { toTitleCase } from "../../../common/common";
// import { useSelector } from "react-redux";
import { useToast } from "../../../common/toastSystem";
import { controlPanelAPI } from "../../../supports/streamEvent";
import { isString } from "lodash";

// Generate HMAC-SHA256 signature for Broadbean authentication

async function generateBroadbeanSignature(
  username,
  apiKey,
  secretKey,
  timestamp = null,
) {
  const time = timestamp || Date.now();
  const message = `${username}|${time}|${apiKey}`;

  const encoder = new TextEncoder();
  const keyData = encoder.encode(secretKey);

  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyData,
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"],
  );

  const messageData = encoder.encode(message);
  const signatureBuffer = await crypto.subtle.sign(
    "HMAC",
    cryptoKey,
    messageData,
  );

  const signatureArray = Array.from(new Uint8Array(signatureBuffer));
  const signature = signatureArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  return {
    timestamp: time,
    signature: signature,
    message: message,
  };
}
const JobDataDetailed = ({
  jobDetails,
  smartMatchLoading,
  smartMatchError,
  handleSmartMatchClick,
  handleOpenBroadbeanModal,
  activeTab,
  setActiveTab,
  applicants,
  loadingApplicants,
  applicantsError,
  enhancedDescription,
  handleEnhanceDescriptionClick,
  sidebarRef,
  loadingOtherJobs,
  otherJobs,
  otherJobsError,
  handleOtherJobClick,
  broadBeanUser,
  onRefreshJobDetails,
}) => {
  const { nationalities, languages, fetchLanguages, fetchNationalities } =
    useDropdownData();

  const [isMandatoryFieldsExist, setMandatoryFields] = useState(false);
  const [downloadingJd, setDownloadingJd] = useState(false);
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const [jdModalOpen, setJdModalOpen] = useState(false);
  const [editSessionModal,seteditSessionModal] = useState(false);
  const [validationErrors, setValidationErrors] = useState(false);
  const [validationErrorList, setValidationErrorList] = useState([]);
  const [aiGeneratedContent, setAiGeneratedContent] = useState("");
   const [text, setText] = useState("");
   const [isNewDescription, setIsNewDescription] = useState(false); 
   const [previousDescription, setPreviousDescription] = useState("");  
   const [showStreamingWarning, setShowStreamingWarning] = useState(false);
   const [pendingAction, setPendingAction] = useState(null);

  const [jdModalContent, setJdModalContent] = useState({
    url: null,
    filename: null,
    mimeType: null,
  });
  const [savingJd, setSavingJd] = useState(false);
  const [saveError, setSaveError] = useState(null);
  const [promptText, setPromptText] = useState("");
  const [specTab, setSpecTab] = useState("skills");

  const toast = useToast();

  // Broadbean posting states
  const [isPostingBroadbean, setIsPostingBroadbean] = useState(false);
  const [broadbeanError, setBroadbeanError] = useState(null);
  const [bbConfig, setBbConfig] = useState({ api_key: "", secret_key: "", client_id: "" });

  const manadatoryParams = jobDetails.manadatoryParams;
  const user = unifiedAuthManager.getUnifiedUser();
  // const jobDetailsState = useSelector((state) => state.jobDetails);
  const recruiters = jobDetails?.recruiters || []; // Array from All Jobs tab
  // const recruiterFirstName = jobDetailsState.recruiterFirstName || "";
  // const recruiterLastName = jobDetailsState.recruiterLastName || "";
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [originalText, setOriginalText] = useState("");
  const [editedDescription, setEditedDescription] = useState("");
  const [originalMarkdown, setOriginalMarkdown] = useState("");
  const [editMarkdownContent, setEditMarkdownContent] = useState("");
  const [smartAssistLoading, setSmartAssistLoading] = useState(false);
  const[isstreaming,setIsStreaming]=useState(false);
  const contentRef = useRef(null);
  const [noChanges, setNoChanges] = useState(false);
  const messages = ["Updating job description", "Saving changes…"];
  const [isEditingSpecs, setIsEditingSpecs] = useState(false);
  const [showUnsavedModal, setShowUnsavedModal] = useState(false);
  const [pendingTab, setPendingTab] = useState(null);
  const [isTextArea, setIsTextArea] = useState(false );
  // Editable field states
  const [editedSkills, setEditedSkills] = useState([]);
  const [newSkill, setNewSkill] = useState("");
  const [editedResponsibilities, setEditedResponsibilities] = useState([]);
  const [editedExperienceMin, setEditedExperienceMin] = useState("");
  const [editedExperienceMax, setEditedExperienceMax] = useState("");
  const [editedExperience, setEditedExperience] = useState([]);

  const [editedEducation, setEditedEducation] = useState([]);
  const [editedLocation, setEditedLocation] = useState("");
  const [editedNationality, setEditedNationality] = useState("");
  const [editedLanguages, setEditedLanguages] = useState([]);
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const firstResponsibilityRef = useRef(null);
  const firstExperienceRef = useRef(null);
  const firstEducationRef = useRef(null);
  const [isAiGenerated, setIsAiGenerated] = useState(false);

  const [responsibilitiesText, setResponsibilitiesText] = useState("");
  const [qualificationText, setQualificationText] = useState("");
  const [experienceTextData, setExperienceText] = useState("");

  const [showDropdown, setShowDropdown] = useState(false);
  const removeNationality = (code) => {
    setEditedNationalities((prev) => prev.filter((n) => n.code !== code));
  };

  const isFirstChunk = useRef(false);

  const [showSubmitConfirmation, setShowSubmitConfirmation] = useState(false);

  const attributeLabels = {
  education_requirements: "Education requirements",
  capabilities:"Responsibilities & Skills",
  experience:"Experience"
};


useEffect(() => {
  RecruiterApi.getBroadbeanConfig()
    .then((res) => {
      if (res && res.status_code === 200 && res.data) {
        setBbConfig(res.data);
      }
    })
    .catch(() => {});
}, []);

useEffect(() => {
  const handleBeforeUnload = (e) => {
    if (isstreaming) {
      e.preventDefault();
      e.returnValue = 'AI is currently generating content. Are you sure you want to leave?';
      return e.returnValue;
    }
  };

  window.addEventListener('beforeunload', handleBeforeUnload);
  
  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };
}, [isstreaming]);


const checkStreamingBeforeAction = (action) => {
  console.log(isstreaming)
  if (isstreaming) {
     console.log(isstreaming)
    setPendingAction(() => action);
    setShowStreamingWarning(true);
    return false;
  }
  return true;
};

// Add this function to handle the warning modal actions
const handleProceedWithAction = () => {
  setShowStreamingWarning(false);
  if (pendingAction) {
    pendingAction();
    setPendingAction(null);
  }
};

const handleCancelAction = () => {
  setShowStreamingWarning(false);
  setPendingAction(null);
};

// Update the handleTabChange function to check for streaming
const handleTabChange = (nextTab) => {
  // If streaming, show warning and stop
  if (isstreaming) {
    setPendingAction(() => () => performTabChange(nextTab));
    setShowStreamingWarning(true);
    return;
  }

  // Not streaming, proceed normally
  performTabChange(nextTab);
};

// Extract the actual tab change logic into a separate function
const performTabChange = (nextTab) => {
  if (!isEditingDescription && !isEditingSpecs) {
    setActiveTab(nextTab);
    return;
  }

  if (!hasUnsavedChanges()) {
    setIsEditingDescription(false);
    setIsEditingSpecs(false);
    setActiveTab(nextTab);
    return;
  }

  const confirmLeave = window.confirm(
    "You have unsaved changes. If you leave this tab, your changes will be lost.\n\nDo you want to continue?",
  );

  if (confirmLeave) {
    setIsEditingDescription(false);
    setIsEditingSpecs(false);
    setEditedDescription("");
    setEditedSkills([]);
    setEditedResponsibilities([]);
    setEditedExperienceMin("");
    setEditedExperienceMax("");
    setEditedEducation([]);
    setEditedLocation("");
    setEditedNationality("");
    setEditedLanguages("");
    setActiveTab(nextTab);
  }
};


useEffect(() => {
  if (aiGeneratedContent && contentRef.current) {
    // Scroll the content to bottom when AI content is streaming
    contentRef.current.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'end' 
    });
  }
}, [aiGeneratedContent]);

  const addNationality = (value) => {
    const selected = nationalities.data.find((n) => n.value === value);

    if (!selected) return;

    setEditedNationalities((prev) => {
      if (prev.some((n) => n.code === selected.value)) return prev;
      return [...prev, { code: selected.value, libelle: selected.label }];
    });

    setShowDropdown(false);
  };

  const removeLanguage = (code) => {
    setEditedLanguages((prev) => prev.filter((l) => l.code !== code));
  };

  const addLanguage = (value) => {
    const selected = languages?.data?.find(
      (l) => String(l.value) === String(value),
    );

    if (!selected) return;

    // Default to level 2 (Average) when adding a new language
    // You might want to add a level selector UI later
    setEditedLanguages((prev) => {
      if (prev.some((l) => l.code === String(selected.value))) return prev;
      return [
        ...prev,
        {
          code: String(selected.value),
          libelle: selected.label,
          level_code: 2, // Default level
          level_libelle: "Average", // Default level label
        },
      ];
    });

    setShowLanguageDropdown(false);
  };

  const loggedInUserId = Number(localStorage.getItem("unified_auth_user_id"));

  const isRecruiterForThisJob = Array.isArray(recruiters)
    ? recruiters.some((r) => Number(r?.user_id) === loggedInUserId)
    : false;

  const isJobClosedWon = ["closed - won", "closed - lost"].includes(
    jobDetails?.job_opening_status_name?.toLowerCase()
  );

  const selectedNationality = jobDetails?.preferred_nationalities || [];
  const [editedNationalities, setEditedNationalities] = useState(
    selectedNationality || [],
  );

  const selectedLanguages = jobDetails?.preferred_languages || [];

  const capabilitiesText =
    (jobDetails?.capabilities?.capabilities || []).length > 0
      ? jobDetails?.capabilities?.capabilities
          .map((item) => `• ${item}`)
          .join("\n")
      : "-";
  const experienceText =
    (jobDetails?.experience_required || []).length > 0
      ? jobDetails?.experience_required.map((item) => `• ${item}`).join("\n")
      : "-";

  const educationalText =
    (jobDetails?.education_requirements || []).length > 0
      ? jobDetails?.education_requirements.map((item) => `• ${item}`).join("\n")
      : "-";

  const hasLoadedDropdowns = useRef(false);

  useEffect(() => {
    if (hasLoadedDropdowns.current) return;

    hasLoadedDropdowns.current = true;

    const loadDropdowns = async () => {
      await fetchNationalities();
      await fetchLanguages();
    };

    loadDropdowns();
  }, []);

  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (isEditing && editedResponsibilities?.length) {
      setResponsibilitiesText(
        editedResponsibilities.map((r) => `• ${r}`).join("\n"),
      );
    }
  }, [isEditing, editedResponsibilities]);

  useEffect(() => {
    if (!isEditingSpecs) return;

    const source = Array.isArray(jobDetails?.experience_required)
      ? jobDetails.experience_required
      : [];

    setExperienceText(source.map((e) => `• ${e}`).join("\n"));
  }, [isEditingSpecs, jobDetails]);
  useEffect(() => {
    if (!isEditingSpecs) return;

    const source = Array.isArray(jobDetails?.education_requirements)
      ? jobDetails.education_requirements
      : [];

    setQualificationText(source.map((q) => `• ${q}`).join("\n"));
  }, [isEditingSpecs, jobDetails]);

  const enterEditMode = async () => {
     const requestBody = {
        user_payload: {
          request_id: generateRequestId(),
        },
        job_id: jobDetails.id,
        user_id : loggedInUserId,
        is_active: true
      };
 
      console.log("Saving Specifications with requestBody:", requestBody);
 
      const response = await RecruiterApi.check_edit_availability(requestBody);
      console.log("Check Edit Availability response:", response);
      if(response && response.status_code === 200 && response.status === "Success"){
        if(response.data?.data === null){
          // reserve the edit session for that user
          const res = await RecruiterApi.start_edit_session(requestBody);
          console.log("Save new session response:", res);
          
          if(res && res.status_code===200 && res.status==="Success"){
            openEditMode();
          }else{
            toast.warning("Something went worng. Please try again later")
          }
        }else{
          // already reserverd
          if(response.data?.data.user_id != loggedInUserId ){
            seteditSessionModal(true);
          }else{
            openEditMode();
          }
          
        }
      }else{
 
      }
  };

  const openEditMode = () => {
    setIsEditing(true);
    setIsEditingSpecs(true);

    // initialize ALL editable fields
    setEditedSkills([...(jobDetails.skills_required || [])]);
    setEditedResponsibilities(
      Array.isArray(jobDetails.capabilities?.capabilities)
        ? [...jobDetails.capabilities.capabilities]
        : [],
    );
    setEditedExperienceMin(jobDetails.experience_min || "");
    setEditedExperienceMax(jobDetails.experience_max || "");

    setEditedExperience(
      Array.isArray(jobDetails.experience_required)
        ? [...jobDetails.experience_required]
        : [],
    );

    setEditedEducation(
      Array.isArray(jobDetails.education_requirements)
        ? [...jobDetails.education_requirements]
        : [],
    );

    setEditedLocation(jobDetails.location || jobDetails.city || "");
    setEditedNationality(
      Array.isArray(selectedNationality)
        ? selectedNationality.map((n) => ({
            code: String(n.code),
            libelle: n.libelle,
          }))
        : [],
    );
    setEditedLanguages(
      Array.isArray(selectedLanguages)
        ? selectedLanguages.map((l) => ({
            code: String(l.code),
            libelle: l.libelle,
            level_code: l.level_code,
            level_libelle: l.level_libelle,
          }))
        : [],
    );
  }
  const handleBulletEnter = (e, value, setValue) => {
    if (e.key !== "Enter") return;

    e.preventDefault();

    const textarea = e.target;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    const before = value.slice(0, start);
    const after = value.slice(end);

    // If cursor is at a new line already, still add bullet
    const bullet = "\n• ";

    const newValue = before + bullet + after;
    setValue(newValue);

    // Move cursor after the bullet
    requestAnimationFrame(() => {
      textarea.selectionStart = textarea.selectionEnd =
        start + bullet.length;
    });
  };
  const handleSmartBulletEnter = (e, value, setValue) => {
  if (e.key !== "Enter") return;

  const textarea = e.target;
  const start = textarea.selectionStart;
  const end = textarea.selectionEnd;

  // Current line text
  const beforeCursor = value.slice(0, start);
  const currentLine = beforeCursor.split("\n").pop();

  // Only auto-bullet if current line starts with a bullet
  if (!currentLine.trim().startsWith("•")) {
    return; // normal Enter behaviour
  }

  e.preventDefault();

  const bullet = "\n• ";
  const afterCursor = value.slice(end);

  const newValue = beforeCursor + bullet + afterCursor;
  setValue(newValue);

  // Move cursor after bullet
  requestAnimationFrame(() => {
    textarea.selectionStart = textarea.selectionEnd =
      start + bullet.length;
  });
};

const exitEditMode = () => {
  setIsEditingSpecs(false);

  // reset edited values
  setEditedSkills([]);
  setEditedResponsibilities([]);
  setEditedExperience([]);
  setEditedEducation([]);
  setEditedExperienceMin("");
  setEditedExperienceMax("");
  setEditedLocation("");
  setEditedNationality([]);
  setEditedLanguages([]);
  
  // Reset textarea values
  setResponsibilitiesText("");
  setQualificationText("");
  setExperienceText("");
  
  // Reset to original values
  setEditedNationalities(selectedNationality || []);
};

  const hasSpecificationChanges = () => {
    const changes = buildEditedFieldsData();
    return changes.length > 0;
  };

  // Helper function to compare arrays deeply
  const areArraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;

    const sorted1 = [...arr1].sort((a, b) => {
      const key1 = a.code || a;
      const key2 = b.code || b;
      return String(key1).localeCompare(String(key2));
    });

    const sorted2 = [...arr2].sort((a, b) => {
      const key1 = a.code || a;
      const key2 = b.code || b;
      return String(key1).localeCompare(String(key2));
    });

    return JSON.stringify(sorted1) === JSON.stringify(sorted2);
  };

  // Helper function to convert textarea content to array
  const textareaToArray = (text) => {
    if (!text || typeof text !== "string") return [];

    return text
      .split("\n")
      .map((line) => line.replace(/^•\s?/, "").trim())
      .filter((line) => line !== "");
  };

  // Helper function to normalize arrays for comparison
  const normalizeArray = (arr) => {
    if (!Array.isArray(arr)) return [];
    return arr.map((item) => String(item).trim()).filter((item) => item !== "");
  };

  // Track which fields were actually edited
  const buildEditedFieldsData = () => {
    const changedAttributes = [];

    // Check Nationality
    const originalNationalities =
      selectedNationality?.map((n) => ({
        code: n.code,
        libelle: n.libelle,
      })) || [];

    if (!areArraysEqual(editedNationalities, originalNationalities)) {
      changedAttributes.push({
        attribute: "preferred_nationalities",
        value: editedNationalities,
      });
    }

    // Check Languages
    const originalLanguages =
      selectedLanguages?.map((l) => ({
        code: String(l.code),
        libelle: l.libelle,
        level_code: l.level_code,
        level_libelle: l.level_libelle,
      })) || [];

    if (!areArraysEqual(editedLanguages, originalLanguages)) {
      changedAttributes.push({
        attribute: "preferred_languages",
        value: editedLanguages,
      });
    }

    // Check Responsibilities and Skills
    const originalResponsibilities = Array.isArray(
      jobDetails.capabilities?.capabilities,
    )
      ? jobDetails.capabilities.capabilities
      : [];

    const editedResponsibilitiesArray = textareaToArray(responsibilitiesText);

    if (
      !areArraysEqual(
        normalizeArray(editedResponsibilitiesArray),
        normalizeArray(originalResponsibilities),
      )
    ) {
      changedAttributes.push({
        attribute: "capabilities",
        value: responsibilitiesText,
      });
    }

    // Check Experience
    const originalExperience = Array.isArray(jobDetails.experience_required)
      ? jobDetails.experience_required
      : [];

    const editedExperienceArray = textareaToArray(experienceTextData);

    if (
      !areArraysEqual(
        normalizeArray(editedExperienceArray),
        normalizeArray(originalExperience),
      )
    ) {
      changedAttributes.push({
        attribute: "experience",
        value: experienceTextData,
      });
    }

    // Check Required Qualification
    const originalEducation = Array.isArray(jobDetails.education_requirements)
      ? jobDetails.education_requirements
      : [];

    const editedEducationArray = textareaToArray(qualificationText);

    if (
      !areArraysEqual(
        normalizeArray(editedEducationArray),
        normalizeArray(originalEducation),
      )
    ) {
      changedAttributes.push({
        attribute: "education_requirements",
        value: qualificationText,
      });
    }

    return changedAttributes;
  };

  // Save specifications
  const handleSaveSpecifications = async () => {
    const changedAttributes = buildEditedFieldsData();

    if (changedAttributes.length === 0) {
      toast.warning("No changes detected in specifications");
      return;
    }

    try {
      setSavingJd(true);

      // Log the changes in the requested format
      console.log(
        "Changed Attributes:",
        JSON.stringify(changedAttributes, null, 2),
      );

      const requestBody = {
        user_payload: {
          request_id: generateRequestId(),
        },
        job_id: jobDetails.id,
        data: changedAttributes,
      };

      console.log("Saving Specifications with requestBody:", requestBody);
      const response = await RecruiterApi.edit_job_description(requestBody);
      console.log("Save Specifications response:", response);
      if (
        response &&
        response.status_code === 200 &&
        response.status === "Success"
      ) {
        setIsEditingSpecs(false);
        // Refresh job details
        if (onRefreshJobDetails) {
          await onRefreshJobDetails(jobDetails.mph_jobid);
        }
      } else if ( response && response.status_code === 400 &&
        response.status === "Error"){
          setValidationErrorList(response.data?.errors || []);
          setValidationErrors(true);
          // console.log(response.data)
          // console.error("Failed to update specifications:", response.message);
          // toast.warning(response.message || "Please provide all the required details to update the job.");
      }
      else {
        console.error("Failed to update specifications:", response.message);
        toast.warning("Failed to update the job details. Please try again.");
      }
    } catch (error) {
      console.error("Failed to save specifications:", error);
      toast.error("Failed to update the job details. Please try again.");
    } finally {
      setSavingJd(false);
    }
  };

const handleCancelSpecEdit = async () => {
  const requestBody = {
    user_payload: {
      request_id: generateRequestId(),
    },
    job_id: jobDetails.id,
    user_id: loggedInUserId,
    is_active: true
  };

  console.log("Ending the edit session for job with requestBody:", requestBody);

  const response = await RecruiterApi.end_edit_session(requestBody);
  console.log("End Edit session response:", response);
  if(response && response.status_code === 200 && response.status === "Success"){
     console.log("Session ended successfully");
  }else{
    console.log("Session cannot be ended due to "+response.error);
  }

  // Reset all edited states to original values from jobDetails
  setIsEditingSpecs(false);
  setIsAiGenerated(false);
  setIsEditingDescription(false);
  
  // Reset edited values to empty/default
  setEditedSkills([]);
  setEditedResponsibilities([]);
  setEditedExperience([]);
  setEditedEducation([]);
  setEditedExperienceMin("");
  setEditedExperienceMax("");
  setEditedLocation("");
  setEditedNationality([]);
  setEditedLanguages([]);
  
  // Reset textarea values to original
  setResponsibilitiesText("");
  setQualificationText("");
  setExperienceText("");
  
  // Reset nationalities and languages to original
  setEditedNationalities(selectedNationality || []);
  
  // Clear any errors
  setValidationErrors(false);
  setValidationErrorList([]);
};

  useEffect(() => {
    const result = validateMandatoryParams(manadatoryParams);
    setMandatoryFields(result);
  }, [manadatoryParams]);

  const [mandatoryParams, setMandatoryParams] = useState(manadatoryParams);
  const hasDescriptionChanges = () => {
    if (isAiGenerated) return true; // 👈 force enable save
    if (!editedDescription?.trim()) return false;
    return editedDescription.trim() !== originalText.trim();
  };

  const isSaveDisabled =
    savingJd ||
    (isEditingDescription && !hasDescriptionChanges()) ||
    (isEditingSpecs && !hasSpecificationChanges());

  const hasUnsavedChanges = () => {
    if (isEditingDescription) {
      return hasDescriptionChanges();
    }

    if (isEditingSpecs) {
      return hasSpecificationChanges();
    }

    return false;
  };
  // const handleTabChange = (nextTab) => {
  //   // If not editing anything, switch freely
  //   if (!isEditingDescription && !isEditingSpecs) {
  //     setActiveTab(nextTab);
  //     return;
  //   }

  //   // Editing but no actual changes
  //   if (!hasUnsavedChanges()) {
  //     setIsEditingDescription(false);
  //     setIsEditingSpecs(false);
  //     setActiveTab(nextTab);
  //     return;
  //   }

  //   // Unsaved changes → confirm
  //   const confirmLeave = window.confirm(
  //     "You have unsaved changes. If you leave this tab, your changes will be lost.\n\nDo you want to continue?",
  //   );

  //   if (confirmLeave) {
  //     // Reset edit states
  //     setIsEditingDescription(false);
  //     setIsEditingSpecs(false);

  //     // Reset edited values (important)
  //     setEditedDescription("");
  //     setEditedSkills([]);
  //     setEditedResponsibilities([]);
  //     setEditedExperienceMin("");
  //     setEditedExperienceMax("");
  //     setEditedEducation([]);
  //     setEditedLocation("");
  //     setEditedNationality("");
  //     setEditedLanguages("");

  //     setActiveTab(nextTab);
  //   }
  // };

  const isDeadlinePassed = (deadlineDate) => {
    if (!deadlineDate) return false;
    const deadline = new Date(deadlineDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of day for accurate comparison
    return deadline < today;
  };

  // Better HTML to text conversion that preserves structure
  const htmlToFormattedText = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    const processNode = (node, indent = "") => {
      let text = "";

      node.childNodes.forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          text += child.textContent;
        } else if (child.nodeType === Node.ELEMENT_NODE) {
          const tagName = child.tagName.toLowerCase();

          if (["p", "div"].includes(tagName)) {
            text += processNode(child, indent) + "\n\n";
          } else if (tagName === "br") {
            text += "\n";
          } else if (["h1", "h2", "h3", "h4", "h5", "h6"].includes(tagName)) {
            text += processNode(child, indent) + "\n\n";
          } else if (tagName === "hr") {
            text += "---\n\n";
          } else if (tagName === "li") {
            text += indent + "• " + processNode(child, indent + "  ") + "\n";
          } else if (["ul", "ol"].includes(tagName)) {
            text += "\n" + processNode(child, indent) + "\n";
          } else if (tagName === "strong" || tagName === "b") {
            text += processNode(child, indent);
          } else {
            text += processNode(child, indent);
          }
        }
      });

      return text;
    };

    return processNode(tempDiv)
      .trim()
      .replace(/\n{3,}/g, "\n\n");
  };

  // Enhanced text to markdown conversion
  const textToMarkdown = (text, originalMarkdown) => {
    const lines = text.split("\n");
    const result = [];
    let i = 0;

    while (i < lines.length) {
      let line = lines[i];
      const trimmedLine = line.trim();

      // Preserve empty lines
      if (trimmedLine === "") {
        result.push("");
        i++;
        continue;
      }

      // Check if line is a horizontal rule
      if (trimmedLine === "---") {
        result.push("---");
        i++;
        continue;
      }

      // Detect list items (bullet points)
      if (trimmedLine.startsWith("• ")) {
        const indent = line.match(/^\s*/)[0];
        const content = trimmedLine.substring(2);
        const listMarker = indent.length > 0 ? "  " + "-" : "-";
        result.push(indent + listMarker + " " + content);
        i++;
        continue;
      }

      // Look ahead to determine if this is a heading
      const nextLine = i < lines.length - 1 ? lines[i + 1].trim() : "";

      // Check if this looks like a heading
      const endsWithColon = trimmedLine.endsWith(":");
      const isFollowedByEmpty = nextLine === "";
      const isFollowedByBullets = nextLine.startsWith("•");
      const isShortLine = trimmedLine.length < 100;
      const isNotSentence =
        !trimmedLine.endsWith(".") && !trimmedLine.endsWith(",");

      // Section headings (like "Key Responsibilities:", "Job Title:", etc.)
      if (isShortLine && endsWithColon) {
        // Add blank line before heading if not at start
        if (result.length > 0 && result[result.length - 1] !== "") {
          result.push("");
        }
        result.push("**" + trimmedLine + "**");
        result.push("");
        i++;
        continue;
      }

      // Other potential headings
      if (
        isShortLine &&
        isNotSentence &&
        (isFollowedByEmpty || isFollowedByBullets) &&
        !trimmedLine.startsWith("•")
      ) {
        // Add blank line before heading if not at start
        if (result.length > 0 && result[result.length - 1] !== "") {
          result.push("");
        }
        result.push("**" + trimmedLine + "**");
        result.push("");
        i++;
        continue;
      }

      // Regular paragraph text
      // Add the line and ensure there's a blank line after for proper markdown paragraph
      result.push(trimmedLine);

      // If next line is not empty and not a bullet, add a blank line for paragraph break
      if (nextLine !== "" && !nextLine.startsWith("•")) {
        result.push("");
      }

      i++;
    }

    // Clean up excessive blank lines (more than 2 in a row)
    let finalResult = result.join("\n").replace(/\n{3,}/g, "\n\n");

    return finalResult;
  };

  // When edit button is clicked
  // Updated handleEditClick function with auto-scroll
  const handleEditClick = async () => {
    
    const requestBody = {
        user_payload: {
          request_id: generateRequestId(),
        },
        job_id: jobDetails.id,
        user_id : loggedInUserId,
        is_active: true
      };
 
      console.log("Saving Specifications with requestBody:", requestBody);
 
      const response = await RecruiterApi.check_edit_availability(requestBody);
      console.log("Check Edit Availability response:", response);
      if(response && response.status_code === 200 && response.status === "Success"){
        if(response.data?.data === null){
          // reserve the edit session for that user
          const res = await RecruiterApi.start_edit_session(requestBody);
          console.log("Save new session response:", res);
          
          if(res && res.status_code===200 && res.status==="Success"){
            openCRMEditMode();
          }else{
            toast.warning("Something went worng. Please try again later")
          }
        }else{
          // already reserverd
          if(response.data?.data.user_id != loggedInUserId ){
            seteditSessionModal(true);
          }else{
            openCRMEditMode();
          }
          
        }
      }else{
 
      }
    };
   const openCRMEditMode = () =>{
    setNoChanges(false);
    const currentDescription =
      enhancedDescription ?? jobDetails?.complete_job_description ?? "";

    const renderedHtml = DOMPurify.sanitize(
      marked
        .parse(preprocessMarkdown(currentDescription))
        .replace(/<(h[1-6])([^>]*)>/g, '<$1$2 class="mph-primary text-sm">'),
    );

    const formattedText = htmlToFormattedText(renderedHtml);

    // 🔑 reset baseline
    setOriginalMarkdown(currentDescription);
    setOriginalText(formattedText);
    setEditedDescription(formattedText);
    setIsEditingDescription(true);
    setTimeout(() => {
      // Scroll the main scrollable container smoothly to bottom
      const scrollContainer = document.querySelector(
        ".h-\\[calc\\(100vh-16rem\\)\\].overflow-y-auto",
      );
      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: scrollContainer.scrollHeight,
          behavior: "smooth",
        });
      }
    }, 150);

    }
  const handleSaveDescription = () => {
    const hasChanges = hasDescriptionChanges();

    if (!hasChanges) {
      toast.warning("No changes detected in job description");
      return;
    }

    const markdownContent = textToMarkdown(editedDescription, originalMarkdown);

    handleSave(markdownContent);
  };

  // Updated helper function for JobDataDetailed - shows ALL names
  const formatRecruitersDisplay = (
    recruitersArray,
    singleFirstName,
    singleLastName,
  ) => {
    // Priority 1: Use array if available (All Jobs tab) - show ALL names
    if (recruitersArray && recruitersArray.length > 0) {
      const names = recruitersArray
        .map((r) =>
          toTitleCase(`${r.first_name || ""} ${r.last_name || ""}`.trim()),
        )
        .filter((name) => name);

      // Show ALL names separated by commas - no truncation
      return names.join(", ");
    }


    // Priority 3: Not assigned
    return <span className="italic text-xs">-</span>;
  };




const handleOpen = () => {
}
const handleClose = () => {
}
const handleStream = (chunk) => {
    try {
           setText('')
            setSmartAssistLoading(false);
            setIsStreaming(true);

            if(chunk.type==='chunk'){
            setAiGeneratedContent((prevContent) => prevContent + chunk.content);
          }
          else if(chunk.type==='COMPLETED'){
            setIsNewDescription(true)
            setIsTextArea(true) 
            setIsStreaming(false);
            setAiGeneratedContent(chunk.enhanced_jd)
            setPreviousDescription(chunk.original_jd)
          }
          else if(chunk.error){
            toast.error(chunk.error)
            setSmartAssistLoading(false);
            setIsTextArea(true) 
            // setAiGeneratedContent(previousDescription)
            if(previousDescription){
                setIsNewDescription(true)
            }
            else{
                setIsNewDescription(false)
            }
             
            setIsStreaming(false) 
          }
     console.log("Received chunk:", chunk);
    } catch (e) {
        console.error(e);
    }
};




  // UPDATED: AI Assist handler that populates edit mode
  const handleGenerateAiAssist = async () => {
    try {
      setIsNewDescription(false)
      setIsTextArea(prev => !prev);
      setSmartAssistLoading(true);
      setNoChanges(true);
      const requestBody = {
        user_payload: {
          request_id: generateRequestId(),
        },
        // job_id: jobDetails.id,
        // mph_jobid: jobDetails.mph_jobid,
        job_description_crm: aiGeneratedContent || jobDetails.complete_job_description || "",
        job_specification:jobDetails,
        user_prompt:text,
        internal_comments:jobDetails.mph_comments

      };
      isFirstChunk.current = true; 

       let cancel = controlPanelAPI.enhance_job_description({
    body: requestBody,
  onChunk: (chunk) => {
         if (isFirstChunk.current) {
    if (!chunk.error) {
      setAiGeneratedContent(''); // ✅ Reset only on first valid chunk
    }
    isFirstChunk.current = false;
  }
          handleStream(chunk);
        },
    onOpen: () => handleOpen(),
    onClose: () => handleClose(),
    onError: (e) => console.error(e)
});
      console.log("AI Assist Save JD requestBody:", requestBody);
      // const response = await RecruiterApi.enhance_job_description(requestBody);
      // console.log("AI Assist Save JD response:", response);
      // if (response.content) {
      //   const aiMarkdown = response.content;
      //   setAiGeneratedContent(aiMarkdown);
      //   const requestBody = {
      //     user_payload: {
      //       request_id: generateRequestId(),
      //     },
      //     job_id: jobDetails.id,
      //     mph_jobid: jobDetails.mph_jobid,
      //     prompt: aiMarkdown,
      //     is_edit_description: true,
      //     ai_generated: true,
      //   };
      //   console.log("Saving JD with requestBody:", requestBody);
      //   // const response1 = await RecruiterApi.validate_and_save_jd(requestBody);
      //   setNoChanges(false);
      //   setSmartAssistLoading(false);
      //   // if (onRefreshJobDetails) {
      //   //     await onRefreshJobDetails(jobDetails.mph_jobid);
      //   // }
      // }else{
      //   setSmartAssistLoading(false);
      //   toast.warning(
      //     response.message || "Failed to get AI-assisted description",
      //   );
      // }
    } catch (error) {
      console.log("AI Assist Save JD error:", error);
      setSmartAssistLoading(false);
    }
  };


   const handleSaveAiAssist = async () => {
    try {
      // setAiGeneratedContent('');
      setIsTextArea(false);
      setSmartAssistLoading(true);
      // setNoChanges(true);
      const requestBody = {
        user_payload: {
          request_id: generateRequestId(),
        },
        job_id: jobDetails.id,
        mph_jobid: jobDetails.mph_jobid,
        enhanced_jd: aiGeneratedContent ,
        //  job_description_crm: aiGeneratedContent || jobDetails.complete_job_description,

      };

 
      const response = await RecruiterApi.save_enhanced_jd(requestBody);
      if(response.status_code==200){
          setSmartAssistLoading(false);
          if (onRefreshJobDetails) {
            await onRefreshJobDetails(jobDetails.mph_jobid);
        }
      }
      console.log("AI Assist Save JD response:", response);
     
    } catch (error) {
      console.log("AI Assist Save JD error:", error);
      setSmartAssistLoading(false);
    }
  };

  const handleEditSave =async () => {
    if (savingJd) return;

    // 1️⃣ JD Description save (AI Assist OR manual edit)
    if (isEditingDescription) {
      if (!hasDescriptionChanges()) {
        toast.warning("No changes detected in job description");
        return;
      }

      const markdownContent = textToMarkdown(
        editedDescription,
        originalMarkdown,
      );

      handleSave(markdownContent);
      return;
    }

    // 2️⃣ Specification save
    if (isEditingSpecs) {
      if (!hasSpecificationChanges()) {
        toast.warning("No changes detected in specifications");
        return;
      }
      await handleSaveSpecifications();

      const requestBody = {
        user_payload: {
          request_id: generateRequestId(),
        },
        job_id: jobDetails.id,
        user_id : loggedInUserId,
        is_active: true
      };
 
      console.log("Ending the edit session for job with requestBody:", requestBody);
 
      const response = await RecruiterApi.end_edit_session(requestBody);
      console.log("End Edit session response:", response);
      if(response && response.status_code === 200 && response.status === "Success"){
         console.log("Session ended successfully");
      }else{
        console.log("Session cannot be ended due to "+response.error);
      }
    }
  };

  const handleSave = async (markdownContent) => {
    try {
      setSavingJd(true);
      setSaveError(null);
      const requestBody = {
        user_payload: {
          request_id: generateRequestId(),
        },
        job_id: jobDetails.id,
        mph_jobid: jobDetails.mph_jobid,
        prompt: promptText ? promptText : markdownContent,
        is_edit_description: true,
        ai_generated: false,
      };
      console.log("Saving JD with requestBody:", requestBody);
      const response = await RecruiterApi.validate_and_save_jd(requestBody);
      setNoChanges(false);
  
      if (response && response.status_code === 200 && response.status === "Success") {
        setEditMarkdownContent("");
        console.log("JD saved successfully:", response);
        setIsAiGenerated(false);
        if (response.jdComplete === false) {
          setPromptText(response.userPrompt || "");
          const missingFields = getMissingFields(
            response.mandatoryParams || mandatoryParams,
          );
          if (missingFields.length > 0) {
            const fieldsList =
              missingFields.length === 1
                ? missingFields[0]
                : missingFields.length === 2
                  ? `${missingFields[0]} and ${missingFields[1]}`
                  : `${missingFields.slice(0, -1).join(", ")}, and ${
                      missingFields[missingFields.length - 1]
                    }`;

            setSaveError(
              `Job description is incomplete. Missing: ${fieldsList}. Please provide more details.`,
            );
          } else {
            setSaveError(
              "Job description is incomplete. Please provide more details.",
            );
          }
        } else {
          setPromptText("");
          setSaveError(null);
        }

        if (onRefreshJobDetails) {
          onRefreshJobDetails(jobDetails.mph_jobid, {
            complete_job_description: markdownContent,
          });
        }
        // if (onRefreshJobDetails) {
        //     setTimeout(() => {
        //      onRefreshJobDetails(jobDetails.mph_jobid);
        //     }, 10000);
        // }

        if (response.mandatoryParams) {
          setMandatoryParams(response.mandatoryParams);
          const isValid = validateMandatoryParams(response.mandatoryParams);
          setMandatoryFields(isValid);
        }
      } else if (
        response &&
        (response.status_code === 400 || response.status_code === 500)
      ) {
        setSaveError(response.message || "Failed to edit  job description");
        toast.warning(
          response.message ||
            "Please provide a valid content to enrich the job description.",
        );
      }
      const requestBody1 = {
        user_payload: {
          request_id: generateRequestId(),
        },
        job_id: jobDetails.id,
        user_id : loggedInUserId,
        is_active: true
      };
 
    const response1 = await RecruiterApi.end_edit_session(requestBody1);
      console.log("End Edit session response:", response1);
      if(response1 && response1.status_code === 200 && response1.status === "Success"){
         console.log("Session ended successfully");
      }else{
        console.log("Session cannot be ended due to "+response1.error);
      }
    } catch (error) {
      console.error("Failed to save JD:", error);
      setSaveError(error.message || "Failed to save job description");
    } finally {
      setSavingJd(false);
      setIsEditingDescription(false);
    }
  };

  // NEW: Handle Broadbean posting directly
  const handlePostToBroadbean = async () => {
    setIsPostingBroadbean(true);
    setBroadbeanError(null);

    try {
      console.log("Posting job to Broadbean with jobdetails:", jobDetails);

      // Get job description HTML
      const rawHTML = marked.parse(
        preprocessMarkdown(
          enhancedDescription || jobDetails.complete_job_description || "",
        ),
      );
      const styledHTML = rawHTML.replace(
        /<(h[1-6])([^>]*)>/g,
        '<$1$2 class="mph-primary text-sm">',
      );
      const htmlContent = DOMPurify.sanitize(styledHTML, {
        USE_PROFILES: { html: true },
      });

      // const USERNAME = process.env.REACT_APP_BB_USERNAME; // comment out this line for production, as username will be fetched from localStorage which is set during login
      const USERNAME = localStorage.getItem("unified_auth_broadbean_username") // uncomment this line for production
      const API_KEY = bbConfig.api_key;
      const SECRET_KEY = bbConfig.secret_key;
      const auth = await generateBroadbeanSignature(
        USERNAME,
        API_KEY,
        SECRET_KEY,
      );

      const requestBody = {
        authentication: {
          api_key: bbConfig.api_key,
          time: auth.timestamp,
          signature: auth.signature,
        },
        identification: {
          client_id: bbConfig.client_id,
          adc_username: USERNAME,
        },
        transaction: {
          filters: {
            job_reference: jobDetails.mph_jobid,
            custom_fields: [],
          },
          advert: {
            job_title: jobDetails?.title || "",
            job_reference: jobDetails.mph_jobid,
            job_type: jobDetails?.job_type || "Permanent",
            location_query: jobDetails?.location || jobDetails?.city || "",
            industry: jobDetails?.sector_name || "",
            salary_from: jobDetails?.salary_from || 0,
            salary_to: jobDetails?.salary_to || 0,
            salary_currency: jobDetails?.salary_currency || "",
            salary_per: jobDetails?.salary_per || "",
            salary_benefits: jobDetails?.salary_benefits || "",
            skills: jobDetails?.skills_required?.join(", ") || "",
            summary: jobDetails?.summary || "",
            client_details: jobDetails?.client_details || "",
            job_description: htmlContent,
            profile: jobDetails?.profile || "",
            job_offer: jobDetails?.job_offer || "",
            custom_fields: {},
          },
          applyonline: {
            url: "https://profiler-mph.mphglobal.net/profiler/",
          },
          stylesheet: {},
          notify_on_delivery: ``,
          redirect_on_completion: {
            url: ``,
            auto: "true",
          },
          close_on_completion: "true",
        },
      };

      const response = await RecruiterApi.postJobBroadbean(requestBody);

      if (response.success && response.status_code === 200) {
        if (response.data?.url) {
          const broadbeanUrl = response.data.url;

          localStorage.setItem("broadbeanUrl", broadbeanUrl);
          console.log("Broadbean URL:", broadbeanUrl);

          // Open the Broadbean URL in a new tab
          window.open(broadbeanUrl, "_blank", "noopener,noreferrer");
        }
      } else {
        setBroadbeanError(
          response.message || "Failed to post job to Broadbean",
        );
      }
    } catch (err) {
      console.error("Error posting job to Broadbean:", err);
      setBroadbeanError("An error occurred while posting the job");
    } finally {
      setIsPostingBroadbean(false);
    }
  };

  function validateMandatoryParams(params) {
    if (!params || typeof params !== "object") {
      return false;
    }
    for (const key in params) {
      const value = params[key];
      if (value === null || value === undefined || value === "") {
        console.warn(`Validation failed: ${key} is empty`);
        return false;
      }
      if (Array.isArray(value)) {
        if (
          value.length === 0 ||
          value.some((v) => v === null || v === undefined || v === "")
        ) {
          console.warn(
            `Validation failed: ${key} contains empty or invalid values`,
          );
          return false;
        }
      }
    }
    return true;
  }

  const handleOpenJdAttachment = async (type = "view") => {
    try {
      const requestBody = {
        user_payload: {
          request_id: generateRequestId(),
          email: user.email,
        },
        mphjob_id: jobDetails.mph_jobid,
      };
      requestBody.flag = type;
      setDownloadingJd(true);
      const response = await RecruiterApi.getJdAttachment(requestBody);

      let url, filename, mimeType;
      if (response) {
        url = response.data.sas_token_url;
        filename = response.data.blob_name || "job_description_attachment";
        const extension = filename.split(".").pop().toLowerCase();
        if (extension === "pdf") {
          mimeType = "application/pdf";
        } else if (extension === "docx") {
          mimeType =
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        } else if (extension === "doc") {
          mimeType = "application/msword";
        } else {
          mimeType = "application/octet-stream";
        }
      }

      // Open modal with the content

      if (type === "view") {
        setJdModalOpen(true);
        setJdModalContent({ url, filename, mimeType });
      } else {
        if (
          response.data.sas_token_url &&
          (response.data.blob_name || "job_description_attachment")
        ) {
          const link = document.createElement("a");
          link.href = response.data.sas_token_url;
          link.download =
            response.data.blob_name || "job_description_attachment";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
      setDownloadingJd(false);
    } catch (err) {
      setDownloadingJd(false);
      console.error("Failed to open JD attachment:", err);
    }
  };

  const handleCloseModal = () => {
    seteditSessionModal(false);
    setJdModalOpen(false);
    setValidationErrors(false);
      setValidationErrorList([]);
    if (jdModalContent.url) {
      window.URL.revokeObjectURL(jdModalContent.url);
    }
    setJdModalContent({ url: null, filename: null, mimeType: null });
  };

  const handleMaximizeModal = () => {
    if (jdModalContent.url) {
      const url = jdModalContent.url;
      const fileExtension = url.split(".").pop().toLowerCase();

      if (fileExtension === "docx" || fileExtension === "doc") {
        const officeViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
          url,
        )}`;
        window.open(officeViewerUrl, "_blank");
      } else {
        window.open(url, "_blank");
      }
    }
  };

  const handleDownloadFromModal = () => {
    handleOpenJdAttachment("download");
  };

  const getMissingFields = (params) => {
    if (!params || typeof params !== "object") {
      return [];
    }

    const missingFields = [];
    const fieldLabels = {
      designation_title: "designation title",
      primary_skills: "primary skills",
      responsibilities: "key responsibilities",
      education_qualification: "educational qualification",
      sector: "sector",
      years_of_experience: "years of experience",
    };

    for (const key in params) {
      const value = params[key];

      if (value === null || value === undefined || value === "") {
        missingFields.push(fieldLabels[key] || key);
      } else if (Array.isArray(value) && value.length === 0) {
        missingFields.push(fieldLabels[key] || key);
      }
    }

    return missingFields;
  };

  const generatePlaceholder = (params) => {
    const missingFields = getMissingFields(params);

    if (missingFields.length === 0) {
      return "Enter the job details here...";
    }

    // if (missingFields.length === 1) {
    //   return `Please provide the ${missingFields[0]} to complete the JD.`;
    // }

    // if (missingFields.length === 2) {
    //   return `Please provide the ${missingFields[0]} and ${missingFields[1]} required for this job to complete the JD.`;
    // }

    // const lastField = missingFields[missingFields.length - 1];
    // const otherFields = missingFields.slice(0, -1).join(", ");
    // return `Please provide the ${otherFields}, and ${lastField} required for this job to complete the JD.`;

     const formatFieldName = (field) => {
    return field
      .replace(/^required_?/i, '') // Remove "required" or "required_" prefix
      .replace(/_/g, ' ') // Replace underscores with spaces
      .trim()
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
  };

  const formattedFields = missingFields.map(formatFieldName);
  const fieldsList = formattedFields.join(", ");

  return (
    <>
      Complete mandatory fields in Job Specification to enable Smart Match.
      <br />
      Missing fields: {fieldsList}
    </>
  );

  };
  
  const experienceDisplayValue = (() => {
    const min = jobDetails.experience_min;
    const max = jobDetails.experience_max;

    if (min != null && max != null) return `${min}-${max}`;
    if (min != null) return `${min}`;
    return "-";
  })();
  const handleMinExperienceChange = (e) => {
    let value = Number(e.target.value);

    if (isNaN(value)) return;

    value = Math.max(0, Math.min(60, value));

    // If max exists and min >= max → adjust max
    if (editedExperienceMax !== "" && Number(editedExperienceMax) <= value) {
      setEditedExperienceMax(value + 1 <= 60 ? value + 1 : 60);
    }

    setEditedExperienceMin(value);
  };
  const handleMaxExperienceChange = (e) => {
    let value = Number(e.target.value);

    if (isNaN(value)) return;

    value = Math.max(0, Math.min(60, value));

    // If min exists and max <= min → block update
    if (editedExperienceMin !== "" && value <= Number(editedExperienceMin)) {
      return;
    }

    setEditedExperienceMax(value);
  };

  return (
    <div className="mx-auto px-3 pb-8">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* === Job Details Section === */}
        <div
          className={`pr-2 ${
            isSidebarExpanded ? "lg:col-span-2" : "lg:col-span-3"
          }`}
        >
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 pb-0 min-h-[calc(100vh-9rem)] max-h-[calc(100vh-9rem)]">
            {/* Job Header */}
            <div className="flex justify-between items-start gap-4">
              {/* ===== LEFT SIDE ===== */}
              <div className="min-w-0">
                {/* Title + badges row */}
                <div className="flex flex-wrap items-center gap-2 min-w-0">
                  <p className="mph-primary text-md font-semibold px-2 py-1 rounded-full">
                    {jobDetails.title} - {jobDetails.mph_jobid}
                  </p>

                  <SkillBadge size="sm" className="bg-gray-200 text-gray-800">
                    {jobDetails.job_opening_status_name}
                  </SkillBadge>

                  <SkillBadge size="sm" className="bg-gray-200 text-gray-800">
                    {jobDetails.sector_name}
                  </SkillBadge>
                </div>
              </div>

              {/* ===== RIGHT SIDE ===== */}
              <div className="flex items-center gap-2 whitespace-nowrap">
                {/* Deadline */}
                {jobDetails.application_deadline_datetime && (
                  <div className="text-xs text-gray-600">
                    <span className="text-gray-500">Deadline :</span>{" "}
                    <span
                      className={`font-medium ${
                        isDeadlinePassed(
                          jobDetails.application_deadline_datetime,
                        )
                          ? "text-[#a51d1d] bg-red-50 px-2 py-1 rounded-full"
                          : "text-gray-800"
                      }`}
                    >
                      {formatPostedOnDate(
                        jobDetails.application_deadline_datetime,
                      )}
                      {isDeadlinePassed(
                        jobDetails.application_deadline_datetime,
                      )}
                    </span>
                  </div>
                )}
                {/* JD Attachment Button in Header */}
                {jobDetails.jd_attached && (
                  <button
                    onClick={() => {
                      if (!downloadingJd) {
                        handleOpenJdAttachment("view");
                      }
                    }}
                    disabled={downloadingJd}
                    title="View / Download JD"
                    className={`
    h-[30px] w-9 rounded-full
    flex items-center justify-center
    border border-gray-300 bg-gradient
    text-white
    hover:opacity-90
    active:scale-95
    transition-all duration-150
    disabled:opacity-50 disabled:cursor-not-allowed
  `}
                  >
                    {downloadingJd ? (
                      <svg
                        className="w-4 h-4 animate-spin"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <circle cx="12" cy="12" r="10" className="opacity-25" />
                        <path d="M4 12a8 8 0 018-8" className="opacity-75" />
                      </svg>
                    ) : (
                      <svg
                        className="w-4 h-4"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 3v12m0 0l-4-4m4 4l4-4M5 21h14"
                        />
                      </svg>
                    )}
                  </button>
                )}

                {/* Buttons */}
                <div className="flex gap-2">
                  {!isMandatoryFieldsExist && !isEditingSpecs && (
                    <div className="mt-0.5 flex items-center">
                      <span
                        className="relative group inline-flex items-center gap-1 
            rounded-full bg-orange-50 px-2.5 py-1
            text-orange-700 text-xs font-medium
            cursor-default animate-softPulse"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 9v2m0 4h.01M12 5a7 7 0 110 14 7 7 0 010-14z"
                          />
                        </svg>
                        Incomplete
                        <span
                            className="pointer-events-none absolute top-full mt-2 -left-16 -translate-x-1/2
                            opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0
                            transition-all duration-200 ease-out
                            w-[360px] max-w-[calc(100vw-2rem)]
                            rounded-md bg-gray-900 px-5 py-3
                            text-[12px] leading-relaxed
                            text-white shadow-lg whitespace-normal break-words"
                          >
                            {generatePlaceholder(mandatoryParams)}
                          </span>
                      </span>
                    </div>
                  )}

                  {isEditingSpecs || isEditingDescription ? (
                    <>
                      {/* Save JD Button */}
                      <button
                        onClick={handleEditSave}
                        disabled={isSaveDisabled}
                        title="Save"
                        className="px-3 py-1.5 text-xs font-semibold rounded-full 
                                  bg-gradient text-white hover:opacity-90
                                  disabled:opacity-50 disabled:cursor-not-allowed
                                  transition-all duration-200 flex items-center gap-2"
                      >
                        {savingJd ? (
                          <svg
                            className="animate-spin h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            />
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            />
                          </svg>
                        ) : (
                          <Save size={16} />
                        )}
                      </button>
                      {/* Cancel Button */}
                      <button
                        onClick={handleCancelSpecEdit}
                        disabled={savingJd}
                        title="Cancel"
                        className="
                            h-8 w-8 rounded-full
                            flex items-center justify-center
                            bg-white text-gray-700 border border-gray-200
                            hover:bg-gray-50 hover:border-gray-300
                            active:scale-95
                            disabled:opacity-50 disabled:cursor-not-allowed
                            transition-all duration-150
                          "
                      >
                        ✕
                      </button>
                    </>
                  ) : (
                    <>
                      {isMandatoryFieldsExist && (
                        <>
                          {/* Smart Match */}
                          <button
                            className={`px-3 py-1.5 text-xs rounded-full flex items-center space-x-2 font-semibold transition
        ${
          smartMatchLoading || isstreaming|| isNewDescription ||
          isJobClosedWon
            ? "bg-gray-400 text-white cursor-not-allowed"
            : "bg-gradient text-white hover:opacity-90"
        }`}
                            onClick={handleSmartMatchClick}
                            disabled={
                              smartMatchLoading || isstreaming ||isNewDescription||
                              jobDetails.job_opening_status_name ===
                                "Closed - Won"
                            }
                          >
                            <svg
                              className="w-4 h-4"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fillRule="evenodd"
                                d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                                clipRule="evenodd"
                              />
                            </svg>
                            <span>
                              {smartMatchLoading ? "Loading..." : "Smart Match"}
                            </span>
                          </button>
                
                  {smartMatchLoading && ( 
                    <div className="fixed inset-0 z-50 bg-black/10 backdrop-blur-sm  flex items-center justify-center">
                      <div className="p-6">
                        <Loader  message="Loading data..." />
                      </div>
                    </div>
                  )}

                          {/* Broadbean */}
                          {broadBeanUser && (
                            <button
                              className={`px-3 py-1.5 text-xs rounded-full flex items-center space-x-2 font-semibold transition
          ${
            isPostingBroadbean ||
            isJobClosedWon
              ? "bg-gray-400 text-white cursor-not-allowed"
              : "bg-gradient text-white hover:opacity-90"
          }`}
                              onClick={handlePostToBroadbean}
                              disabled={
                                isPostingBroadbean ||
                                jobDetails.job_opening_status_name ===
                                  "Closed - Won"
                              }
                            >
                              <span>
                                {isPostingBroadbean
                                  ? "Posting..."
                                  : "Broadbean Advert"}
                              </span>
                            </button>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>

            {smartMatchError && (
              <div className="text-red-500 text-xs mt-2">{smartMatchError}</div>
            )}
            {broadbeanError && (
              <div className="text-red-500 text-xs mt-2">{broadbeanError}</div>
            )}

            {/* Tabs below job name */}
            <div className="border-b flex border-gray-200">
              <nav className="flex space-x-4" aria-label="Tabs">
                <button
                  className={`px-3 py-2 text-xs font-medium focus:outline-none ${
                    activeTab === "specification"
                      ? "border-b-2 border-emerald-900 mph-primary font-semibold"
                      : "text-gray-666 hover:mph-primary"
                  }`}
                  onClick={() => handleTabChange("specification")}
                  type="button"
                >
                  Job Specification
                </button>
                <button
                  className={`px-3 py-2 text-xs font-medium focus:outline-none ${
                    activeTab === "jd_from_crm"
                      ? "border-b-2 border-emerald-900 mph-primary font-semibold"
                      : "text-gray-666 hover:mph-primary"
                  }`}
                  onClick={() => handleTabChange("jd_from_crm")}
                  type="button"
                >
                  Job Description (CRM)
                </button>
                <button
                  className={`px-3 py-2 text-xs font-medium focus:outline-none ${
                    activeTab === "applicants"
                      ? "border-b-2 border-emerald-900 mph-primary font-semibold"
                      : "text-gray-666 hover:mph-primary"
                  }`}
                  onClick={() => handleTabChange("applicants")}
                  type="button"
                >
                  Job Applicants
                </button>
                <button
                  className={`px-3 py-2 text-xs font-medium focus:outline-none ${
                    activeTab === "internal_comments"
                      ? "border-b-2 border-emerald-900 mph-primary font-semibold"
                      : "text-gray-666 hover:mph-primary"
                  }`}
                  onClick={() => handleTabChange("internal_comments")}
                  type="button"
                >
                  Internal Comments
                </button>
              </nav>
                {/* <div className="flex gap-2 items-center text-xs ml-auto justify-end">
                  
                </div> */}
            </div>

            {/* Tab Content */}
            {/* Tab Content */}
            {activeTab === "specification" && (
              <>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-4 py-4 text-xs text-gray-700">
                  {[
                    {
                      label: "Client",
                      value: jobDetails.mph_clientid_value || "-",
                    },
                    {
                      label: "Project",
                      value: jobDetails.mph_project_name || "-",
                    },
                    {
                      label: "Recruiter",
                      value:
                        formatRecruitersDisplay(
                          recruiters,
                          '',
                          '',
                        ) || "-",
                    },
                    {
                      label: "Account Manager",
                      value: jobDetails.mph_account_manager || "-",
                    },

                    { label: "Vacancies", value: jobDetails.vacancy || "-" },
                    {
                      label: "Job Type",
                      value: jobDetails.employment_type_name || "-",
                    },
                    {
                      label: "Location",
                      value: jobDetails.location || jobDetails.city || "-",
                    },
                    {
                      label: "Posted on",
                      value: formatPostedOnDate(jobDetails.job_opening_date),
                    },
                  ].map((info, index) => (
                    <div
                      key={index}
                      className="grid grid-cols-[100px_1fr] items-start gap-2 min-w-0"
                    >
                      {/* Label */}
                      <span className="text-gray-500 text-left whitespace-nowrap">
                        {info.label}
                      </span>

                      {/* Value */}
                      <span
                        className="font-medium text-gray-800 text-left truncate"
                        title={info.value}
                      >
                        :&nbsp; &nbsp; {info.value}
                      </span>
                    </div>
                  ))}
                  {!(isEditingSpecs && isRecruiterForThisJob && !isJobClosedWon) && (
                    <>
                      <InlineEditableField
                        label="Nationality"
                        value={
                          selectedNationality?.length > 0
                            ? selectedNationality.map((n) => n.libelle).join(", ")
                            : "-"
                        }
                        title={
                          selectedNationality?.length > 0
                            ? selectedNationality.map((n) => n.libelle).join(", ")
                            : "-"
                        }
                        isEditing={false}
                        onEdit={
                          isRecruiterForThisJob && !isJobClosedWon ? enterEditMode : undefined
                        }
                      />
                      
                      <InlineEditableField
                        label="Languages"
                        value={
                          selectedLanguages?.length > 0
                            ? selectedLanguages
                                .map((l) => `${l.libelle} - ${l.level_libelle}`)
                                .join(", ")
                            : "-"
                        }
                        title={
                          selectedLanguages?.length > 0
                            ? selectedLanguages
                                .map((l) => `${l.libelle} - ${l.level_libelle}`)
                                .join(", ")
                            : "-"
                        }
                        isEditing={false}
                        onEdit={
                           isRecruiterForThisJob && !isJobClosedWon ?enterEditMode : undefined
                        }
                      />
                    </>
                  )}
                </div>

                <div className="h-[calc(100vh-22rem)] overflow-y-auto pb-4">
                  {isEditingSpecs && isRecruiterForThisJob && !isJobClosedWon && (
                    <div className="grid grid-cols-2 gap-4 py-4 animate-fadeIn">
                      {/* ========== Nationality =======*/}
                      <div className="bg-white  editBox rounded-lg p-4">
                        <h3 className="text-xs font-semibold mph-primary">
                          Nationality
                        </h3>

                        <div className="mt-2 space-y-2">
                          {/* Nationality chips */}
                          <div className="flex flex-wrap items-center gap-2">
                            {editedNationalities.length > 0 ? (
                              editedNationalities.map((item) => (
                                <span
                                  key={item.code}
                                  className="flex items-center gap-1 px-2 py-1
                       text-xs bg-gray-100 text-green-800 rounded-full"
                                >
                                  {item.libelle}
                                  <button
                                    onClick={() => removeNationality(item.code)}
                                    className="hover:text-red-500"
                                  >
                                    ×
                                  </button>
                                </span>
                              ))
                            ) : (
                              <span className="text-xs text-gray-400">-</span>
                            )}

                            {/* Plus button */}
                            {!showDropdown && (
                              <button
                                onClick={() => setShowDropdown(true)}
                                title="Add nationality"
                                className="
            inline-flex items-center justify-center
            rounded-full
            border border-gray-400
            text-green-600
            hover:bg-green-50 hover:border-green-500
            active:scale-95
            transition-all duration-150
          "
                              >
                                <Plus className="w-3.5 h-3.5" />
                              </button>
                            )}
                          </div>

                          {/* Dropdown */}
                          {showDropdown && (
                            <select
                              className="w-full px-2 py-1 border rounded text-xs"
                              onChange={(e) => addNationality(e.target.value)}
                              defaultValue=""
                            >
                              <option value="" disabled>
                                Select nationality
                              </option>
                              {nationalities?.data?.map((item) => (
                                <option key={item.value} value={item.value}>
                                  {item.label}
                                </option>
                              ))}
                            </select>
                          )}
                        </div>
                      </div>

                      {/* ================= Languages ================= */}
                      <div className="bg-white editBox rounded-lg p-4">
                        <h3 className="text-xs font-semibold mph-primary">
                          Languages
                        </h3>

                        <div className="mt-2 space-y-2">
                          {/* Language chips with levels */}
                          <div className="flex flex-wrap items-center gap-2">
                            {editedLanguages.length > 0 ? (
                              editedLanguages.map((item) => (
                                <span
                                  key={item.code}
                                  className="flex items-center gap-1 px-2 py-1
                       text-xs bg-gray-100 text-green-800 rounded-full"
                                >
                                  {item.libelle}
                                  <button
                                    onClick={() => removeLanguage(item.code)}
                                    className="hover:text-red-500"
                                  >
                                    ×
                                  </button>
                                </span>
                              ))
                            ) : (
                              <span className="text-xs text-gray-400">-</span>
                            )}

                            {/* Plus button */}
                            {!showLanguageDropdown && (
                              <button
                                onClick={() => setShowLanguageDropdown(true)}
                                title="Add language"
                                className="
            inline-flex items-center justify-center
            rounded-full
            border border-gray-400
            text-green-600
            hover:bg-green-50 hover:border-green-500
            active:scale-95
            transition-all duration-150
          "
                              >
                                <Plus className="w-3.5 h-3.5" />
                              </button>
                            )}
                          </div>

                          {/* Dropdown */}
                          {showLanguageDropdown && (
                            <select
                              className="w-full px-2 py-1 border rounded text-xs"
                              onChange={(e) => addLanguage(e.target.value)}
                              defaultValue=""
                            >
                              <option value="" disabled>
                                Select language
                              </option>
                              {languages?.data?.map((item) => (
                                <option key={item.value} value={item.value}>
                                  {item.label}
                                </option>
                              ))}
                            </select>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Main 2 Column Layout - 3:1 ratio */}
                  <div className="grid grid-cols-4 gap-4 py-4 h-full">
                    {/* LEFT COLUMN (3/4 width) - 2 rows */}
                    <div className="col-span-2 space-y-4">
                      {/* Row 1: Responsibilities and Skills */}
                      <div className="bg-white  rounded-lg p-4 group h-full flex flex-col editBox">
                        <div className="flex items-center justify-between">
                          <h3 className="text-xs font-semibold mph-primary">
                            Responsibilities and Skills <span className="text-red-500 text-sm">*</span>
                          </h3>
                          {!isEditingSpecs && isRecruiterForThisJob && !isJobClosedWon && (
                            <button
                              onClick={enterEditMode}
                              className="
          p-1.5 rounded-full
          bg-green-100 hover:bg-green-200
          opacity-0 group-hover:opacity-100
          transition-opacity duration-200
        "
                            >
                              <PencilLine className="w-3.5 h-3.5 text-[#004645]" />
                            </button>
                          )}
                        </div>
                        {isEditingSpecs ? (
                          <div className="space-y-2">
                            <textarea
                              ref={firstResponsibilityRef}
                              className="w-full text-xs px-2 py-2 border border-gray-100 rounded mt-2
                                        focus:outline-none focus:ring-2 focus:ring-green-500 resize-none"
                              rows={Math.max(
                                3,
                                responsibilitiesText.split("\n").length,
                              )}
                              placeholder="• Responsibility 1"
                              value={responsibilitiesText}
                              onChange={(e) =>
                                setResponsibilitiesText(e.target.value)
                              }
                              onKeyDown={(e) =>
                                handleBulletEnter(e, responsibilitiesText, setResponsibilitiesText)
                              }
                            />
                          </div>
                        ) : (
                          <textarea
                            className="w-full text-xs text-gray-700 p-2 resize-none bg-white-50 h-full"
                            readOnly
                            value={capabilitiesText}
                          />
                        )}
                      </div>
                    </div>

                    {/* RIGHT COLUMN (1/4 width) - 2 rows */}
                    <div className="col-span-2 grid grid-rows-2 gap-4 h-full">
                      {/* Row 1: Required Experience */}
                     <div className="bg-white rounded-lg p-4 group overflow-hidden h-full editBox">
                        <div className="flex items-center justify-between">
                          <h3 className="text-xs font-semibold mph-primary">
                            Experience  <span className="text-red-500 text-sm">*</span>
                          </h3>

                          
   <div className="flex items-center">
       {(jobDetails.experience_min != null || jobDetails.experience_max != null) && (
   <span className="text-xs font-semibold text-gray-500 px-3">
      Overall Experience:&nbsp; {jobDetails.experience_min ?? jobDetails.experience_max}
      {jobDetails.experience_min != null && 
       jobDetails.experience_max != null && 
       jobDetails.experience_min !== jobDetails.experience_max && 
       ` - ${jobDetails.experience_max}`}
    </span>
)}

                          {!isEditingSpecs && isRecruiterForThisJob && !isJobClosedWon && (
                            <button
                              onClick={enterEditMode}
                              className="p-1.5 rounded-full bg-green-100 hover:bg-green-200
                  hidden group-hover:block transition-opacity"
                            >
                              <PencilLine className="w-3.5 h-3.5 text-[#004645]" />
                            </button>
                          )}
                          </div>


                      
                        </div>

                        {/* EDIT MODE */}
                        {isEditingSpecs ? (
                          <div className="space-y-2 h-full">
                            <textarea
                              className="w-full text-xs px-2 py-2 h-48 border border-gray-100 rounded mt-2
                                      focus:outline-none focus:ring-2 focus:ring-green-500 resize-none bg-transparent"
                              rows={Math.max(
                                3,
                                experienceTextData.split("\n").length,
                              )}
                              value={experienceTextData}
                              onChange={(e) =>
                                setExperienceText(e.target.value)
                              }
                              onKeyDown={(e) =>
                                  handleBulletEnter(e, experienceTextData, setExperienceText)
                              }
                            />
                          </div>
                        ) : (
                          <textarea
                            className="w-full text-xs text-gray-700 p-2 resize-none bg-white-50 h-full bg-transparent"
                            readOnly
                            value={experienceText}
                          />
                        )}
                      </div>

                      {/* Row 2: Qualification */}

                      <div className="bg-white rounded-lg p-4 group h-full editBox">
                        <div className="flex items-center justify-between">
                          <h3 className="text-xs font-semibold mph-primary">
                            Required Qualification  <span className="text-red-500 text-sm">*</span>
                          </h3>

                          {!isEditingSpecs && isRecruiterForThisJob && !isJobClosedWon&& (
                            <button
                              onClick={enterEditMode}
                              className="p-1.5 rounded-full bg-green-100 hover:bg-green-200
                   opacity-0 group-hover:opacity-100 transition-opacity"
                              title="Edit qualification"
                            >
                              <PencilLine className="w-3.5 h-3.5 text-[#004645]" />
                            </button>
                          )}
                        </div>

                        {/* EDIT MODE */}
                        {isEditingSpecs ? (
                          <div className="space-y-2 h-full">
                            <textarea
                              className="w-full text-xs px-2 h-48 py-2 border border-gray-100 rounded mt-2
                                      focus:outline-none focus:ring-2 focus:ring-green-500 resize-none bg-transparent"
                              rows={Math.max(
                                3,
                                qualificationText.split("\n").length,
                              )}
                              placeholder="• Qualification 1"
                              value={qualificationText}
                              onChange={(e) =>
                                setQualificationText(e.target.value)
                              }
                              onKeyDown={(e) =>
                                handleBulletEnter(e, qualificationText, setQualificationText)
                              }
                            />
                          </div>
                        ) : (
                          <textarea
                            className="w-full text-xs text-gray-700 p-2 resize-none bg-white-50 h-full bg-transparent"
                            readOnly
                            value={educationalText}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  {savingJd && (
                    <div className="fixed inset-0 z-50 bg-black/10 backdrop-blur-sm flex items-center justify-center">
                      <div className="p-6">
                        <Loader message="Updating job details..." />
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}

            {activeTab === "jd_from_crm" && (
              <>
                              <div
                  className={`border-green-700 border-b rounded-lg overflow-y-auto transition-all duration-300 ease-in-out ${
                    isTextArea
                      ? "h-[calc(100vh-20rem)]"
                      : "h-[calc(100vh-16rem)]"
                  }`}
                >

                  {smartAssistLoading && (
                    <div className="fixed inset-0 z-50 bg-black/10 backdrop-blur-sm flex items-center justify-center">
                      <div className="p-6">
                        <Loader message="Updating job details..." />
                      </div>
                    </div>
                  )}

                  {savingJd && (
                    <div className="fixed inset-0 z-50 bg-black/10 backdrop-blur-sm flex items-center justify-center">
                      <div className="p-6">
                        <Loader message="Updating job details..." />
                      </div>
                    </div>  
                  )}
                 
                  <div
                    className="group  relative rounded-lg p-4 min-h-[calc(100vh-16rem)]  border-l-4 border-green-700 mt-2"
                    
                  >
                    {/* Edit and AI Assist buttons - show on hover when not editing */}
                    {!isEditingDescription && isRecruiterForThisJob  && !isJobClosedWon && !isstreaming  && (
                      <div className="absolute right-4 top-4 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              
              
                     <button
  type="button"
  disabled={savingJd || smartAssistLoading}
  onClick={() => setIsTextArea(prev => !prev)}
  className={`text-xs px-3 py-1.5 rounded-full border z-10 inline-flex items-center gap-1.5 w-fit
    ${
      smartAssistLoading || savingJd
        ? "cursor-not-allowed opacity-60 bg-gray-100 border-gray-300"
        : "bg-white border-gray-300 hover:bg-green-50 hover:border-green-300"
    } transition-all`}
>
  <IoSparkles className="w-4 h-4 mph-primary" />
  <span className="font-semibold mph-primary">AI Assist</span>
</button>
          
                        {/* Edit Button */}
                        <button
                          title="Edit job description"
                          onClick={handleEditClick}
                          disabled={savingJd || smartAssistLoading || isNewDescription || isTextArea} 
                          className={`p-2 rounded-full z-10 transition-all duration-200
                          ${
                            savingJd || smartAssistLoading || isNewDescription || isTextArea
                              ? "bg-gray-100 cursor-not-allowed opacity-60"
                              : "mph-light hover:bg-gray-200 cursor-pointer"
                          }`}
                        >
                          <PencilLine className="w-4 h-4 text-[#004645]" />
                        </button>
                      </div>
                    )}

                    {/* Content Area */}
                    {isEditingDescription ||
                    enhancedDescription ||  aiGeneratedContent ||
                    jobDetails.complete_job_description ? (
                      <div>
                     {isEditingDescription ? (
  /* Inline Edit Mode */
  <div className="space-y-3">
    <div className="relative bg-white border border-gray-200 rounded-lg shadow-sm flex flex-col overflow-hidden transition-all duration-200 hover:border-gray-300 focus-within:border-emerald-500 focus-within:shadow-md">
      <textarea
        disabled={savingJd}
        value={editedDescription}
        onChange={(e) =>
          setEditedDescription(e.target.value)
        }
        onKeyDown={(e) =>
          handleSmartBulletEnter(e, editedDescription, setEditedDescription)
        }
        className="w-full min-h-[400px] font-medium px-4 py-3 text-xs text-gray-700 leading-relaxed focus:outline-none resize-none disabled:opacity-50 disabled:cursor-not-allowed"
        placeholder="Enter your job description here... Include responsibilities, requirements, and benefits."
      />

      {/* Copy Button */}
      <div className="absolute top-3 right-3">
        <button
          onClick={async () => {
            try {
              const markdownContent = textToMarkdown(
                editedDescription,
                originalMarkdown,
              );
              await navigator.clipboard.writeText(
                markdownContent,
              );
              toast.success("Copied");
            } catch (err) {
              console.error("Failed to copy:", err);
            }
          }}
          disabled={savingJd || !editedDescription}
          className={`group px-3 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-2 ${
            savingJd || !editedDescription
              ? "bg-gray-100 text-gray-400 cursor-not-allowed"
              : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-200 hover:border-gray-300 cursor-pointer"
          }`}
          title="Copy to clipboard"
        >
          <svg
            className="w-4 h-4 transition-transform duration-200 group-hover:scale-110"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
) : (
  /* Display Mode */
 <div className="relative"> {/* Add wrapper for positioning */}
    <div
      ref={contentRef}
      className="prose prose-green max-w-none text-xs leading-relaxed"
    >
      {/* Render Markdown → HTML */}
      <span
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(
            marked
              .parse(
                preprocessMarkdown(
                  aiGeneratedContent ||
                  enhancedDescription ||
                  jobDetails.complete_job_description ||
                  ""
                )
              )
              .replace(
                /<(h[1-6])([^>]*)>/g,
                '<$1$2 class="mph-primary text-sm">'
              )
          ),
        }}
      />

      {/* Streaming Cursor (ChatGPT-style caret) */}
      {isstreaming && (
        <span className="inline-block w-2 h-2 rounded-full ml-1 align-baseline animate-blink"></span>
      )}
    </div>

    {/* Move the buttons OUTSIDE the content div but inside the wrapper */}
    {aiGeneratedContent && isNewDescription && (
      <div className="flex sticky bottom-4 gap-2 items-center justify-end mt-4 pb-2">
 <div 
  title="Undo" 
  onClick={() => {
    if (!previousDescription) return; // Prevent action if disabled
    setAiGeneratedContent(previousDescription);
    setPreviousDescription('');
    setIsTextArea(false);
    setIsStreaming(false);
    setIsNewDescription(false);
  }}
  className={`flex p-1.5 border rounded-full ${
    previousDescription 
      ? 'bg-white hover:scale-105 cursor-pointer' 
      : 'bg-gray-100 cursor-not-allowed opacity-50'
  }`}
>
  <Undo className="w-4 h-4" />
</div>

<div 
  title="Submit" 
  onClick={() => {
    setShowSubmitConfirmation(true)
  }}
  className="flex p-1.5 hover:scale-105 bg-[#8C642A] cursor-pointer rounded-full"
>
  <Check className="w-4 h-4 text-white" />
</div>

<div 
  title="Revert" 
  onClick={() => {
    setAiGeneratedContent('');
    setIsTextArea(false);
    setIsStreaming(false);
    setIsNewDescription(false);
  }}
  className="flex p-1.5 border bg-white hover:scale-105 cursor-pointer rounded-full"
>
  <RotateCcw className="w-4 h-4" />
</div>
      </div>
    )}
  </div>
)}
                      </div>
                    ) : (
                      <div>
                        <p className="text-gray-500 text-xs">
                          No job description available.
                        </p>
                      </div>
                    )}

                  </div>
                     
                </div>
                {isTextArea&&( 
               <div className="w-full p-2 mt-3 flex items-center justify-center">
  <div className="w-[55%] flex gap-2 border items-center px-2 rounded-full">
    <textarea 
      value={text}
      onChange={(e) => setText(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault(); // Prevents adding a new line
          if (text.trim()) { // Only trigger if text is not empty
            handleGenerateAiAssist();
          }
        }
      }}
      placeholder={
        (aiGeneratedContent || enhancedDescription || jobDetails?.complete_job_description)
          ? "How would you like to enhance this job? For example, improve the description or add required skills."
          : "Eg: Generate a job description for this job."
      }
      className="rounded-full w-full text-xs text-gray-700 p-2.5 resize-none bg-white-50 h-full"
    />
    <div 
      onClick={() => {
        if (text.trim()) { // Only trigger if text is not empty
          handleGenerateAiAssist();
        }
      }} 
      className={`p-2.5 rounded-full items-center transition-all ${
        text.trim() 
          ? 'cursor-pointer hover:scale-105 bg-gradient text-white' 
          : 'cursor-not-allowed bg-gray-300 text-gray-500 opacity-50'
      }`}
    >
      <SendHorizontal className="w-5 h-5" />
    </div>
  </div>
</div>
                    )}
                {jobDetails?.ai_generated && (
                  <p className="mt-1 text-center text-gray-400 text-xs">
                    Disclaimer: This job description was generated by AI and may
                    contain inaccuracies. Please review before use.
                  </p>
                )}
              </>
            )}
            {activeTab === "applicants" && (
              <div className="mt-4 h-[calc(100vh-19rem)] overflow-auto">
                <JobApplicantsTable
                  applicants={applicants}
                  loading={loadingApplicants}
                  error={applicantsError}
                />
              </div>
            )}

            {activeTab === "internal_comments" && (
              <div className="mt-4 h-[calc(100vh-19rem)] overflow-auto">
                {jobDetails.mph_comments ? (
                  <div className="whitespace-pre-wrap text-xs text-gray-700">
                    {jobDetails.mph_comments}
                  </div>
                ) : (
                  <div className="text-gray-500 text-xs italic">
                    No internal comments available.
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        {showUnsavedModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
            <div className="bg-white rounded-lg shadow-xl w-[420px] p-5">
              <div className="flex items-center gap-3 mb-3">
                <AlertTriangle className="w-5 h-5 text-amber-600" />
                <h3 className="text-sm font-semibold text-gray-800">
                  Unsaved changes
                </h3>
              </div>

              <p className="text-xs text-gray-600 mb-5">
                You have unsaved changes. If you leave this tab, your changes
                will be lost.
              </p>

              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setShowUnsavedModal(false)}
                  className="px-3 py-1.5 text-xs rounded border border-gray-300
                     hover:bg-gray-50"
                >
                  Stay
                </button>

                <button
                  onClick={() => {
                    exitEditMode();
                    setShowUnsavedModal(false);
                    setActiveTab(pendingTab);
                    setPendingTab(null);
                  }}
                  className="px-3 py-1.5 text-xs rounded bg-red-600 text-white
                     hover:bg-red-700"
                >
                  Discard & Leave
                </button>
              </div>
            </div>
          </div>
        )}

        {/* === Other Jobs Sidebar === */}
        {isSidebarExpanded && (
          <div className="anim-slideLeft">
            <div
              ref={sidebarRef}
              style={{
                maxHeight: "calc(100vh - 9rem)",
                overflowY: "auto",
                minHeight: "200px",
              }}
            >
              {loadingOtherJobs && otherJobs.length === 0 ? (
                <div className="flex justify-center items-center h-full">
                  <Loader message="Loading jobs..." />
                </div>
              ) : otherJobsError ? (
                <div className="text-red-500 text-xs p-4">{otherJobsError}</div>
              ) : (
                <>
                  <OtherJobsSidebar
                    jobs={otherJobs}
                    currentJobId={jobDetails.mph_jobid}
                    onJobClick={handleOtherJobClick}
                  />
                  {loadingOtherJobs && otherJobs.length > 0 && (
                    <div className="flex justify-center items-center py-2">
                      <Loader message="Loading more jobs" />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        )}
        <button
          onClick={() => setIsSidebarExpanded(!isSidebarExpanded)}
          className="fixed right-4 top-1/2 transform -translate-y-1/2 bg-gradient text-white p-2 rounded-full shadow-lg hover:shadow-xl z-10"
          title={isSidebarExpanded ? "Hide Other Jobs" : "Show Other Jobs"}
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            style={{
              transform: isSidebarExpanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s",
            }}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
      </div>

      {/* JD Attachment Modal */}
      {jdModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          onClick={handleCloseModal}
        >
          <div
            className="bg-white rounded-lg shadow-xl w-11/12 h-5/6 flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="flex justify-between items-center p-4 border-b">
              <h2 className="text-lg font-semibold text-gray-800">
                {jdModalContent.filename || "JD Attachment"}
              </h2>
              <div className="flex gap-2">
                <button
                  onClick={handleMaximizeModal}
                  className="text-gray-600 hover:text-gray-800 p-2 rounded hover:bg-gray-100"
                  title="Open in New Tab"
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    />
                  </svg>
                </button>
                <button
                  onClick={handleDownloadFromModal}
                  className="text-gray-600 hover:text-gray-800 p-2 rounded hover:bg-gray-100"
                  title="Download"
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                    />
                  </svg>
                </button>
                <button
                  onClick={handleCloseModal}
                  className="text-gray-600 hover:text-gray-800 p-2 rounded hover:bg-gray-100"
                  title="Close"
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>

            {/* Modal Content */}
            <div className="flex-1 overflow-auto p-4">
              {jdModalContent.mimeType === "application/pdf" ? (
                <iframe
                  src={jdModalContent.url}
                  className="w-full h-full border-0"
                  title="PDF Viewer"
                />
              ) : jdModalContent.mimeType?.startsWith("image/") ? (
                <div className="flex justify-center items-center h-full">
                  <img
                    src={jdModalContent.url}
                    alt="JD Attachment"
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              ) : jdModalContent.mimeType ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                <iframe
                  src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                    jdModalContent.url,
                  )}`}
                  className="w-full h-full border-0"
                  title="Word Document Preview"
                />
              ) : (
                <div className="flex flex-col justify-center items-center h-full text-gray-600">
                  <svg
                    className="w-16 h-16 mb-4"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                    />
                  </svg>
                  <p className="text-sm mb-2">
                    Preview not available for this file type
                  </p>
                  <button
                    onClick={handleDownloadFromModal}
                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm"
                  >
                    Download File
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {editSessionModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-lg shadow-lg w-[360px] p-6 animate-fadeIn text-center">
            
            {/* Icon */}
            <div className="flex justify-center mb-3">
              <svg
                className="w-6 h-6 text-amber-600"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 9v2m0 4h.01M12 5a7 7 0 110 14 7 7 0 010-14z"
                />
              </svg>
            </div>

            {/* Heading */}
            <h3 className="text-sm font-semibold text-gray-800 mb-2">
              Editing in progress
            </h3>

            {/* Message */}
            <p className="text-xs text-gray-600 mb-6 leading-relaxed">
              This job is currently being edited by another recruiter.
              Please check back in a few minutes.
            </p>

            {/* Action */}
            <div className="flex justify-center">
              <button
                onClick={handleCloseModal}
                className="px-6 py-1.5 text-xs font-semibold rounded-md
                          bg-gradient font-700 text-white
                          hover:bg-gray-800
                          transition-colors"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      {validationErrors && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
        <div className="mt-3 rounded-md p-3">
          <div className="bg-white rounded-lg shadow-lg w-[640px] p-6 animate-fadeIn text-center text-xs">
          
            <div className="overflow-x-auto">
              <table className="w-full border border-gray-200 rounded-md text-xs">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-3 py-2 text-left text-gray-700 border-b">
                      Field
                    </th>
                    <th className="px-3 py-2 text-left  text-gray-700 border-b">
                      Message
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {validationErrorList.map((err, index) => (
                    <tr
                      key={`${err.attribute}-${index}`}
                      className="odd:bg-white even:bg-gray-50 hover:bg-red-50 transition"
                    >
                      <td className="px-3 py-2 text-gray-500 border-b align-top text-left text-xs capitalize">
                         {attributeLabels[err.attribute] || err.attribute}
                      </td>
                      <td className="px-3 py-2 text-gray-500 border-b text-left text-xs">
                        {err.reason}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Action */}
            <div className="flex justify-center mt-2">
              <button
                onClick={handleCloseModal}
                className="px-6 py-1.5 text-xs font-semibold rounded-md
                          bg-gradient font-700 text-white
                          hover:bg-gray-800
                          transition-colors"
              >
                OK
              </button>
            </div>
          </div>
          
        </div>
        </div>
      )}


      {showStreamingWarning && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
    <div className="bg-white rounded-lg shadow-xl w-[420px] p-5 animate-fadeIn">
      <div className="flex items-center gap-3 mb-3">
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-amber-100">
          <svg
            className="w-6 h-6 text-amber-600"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v2m0 4h.01M12 5a7 7 0 110 14 7 7 0 010-14z"
            />
          </svg>
        </div>
        <h3 className="text-sm font-semibold text-gray-800">
          Content Generation in Progress
        </h3>
      </div>

      <p className="text-xs text-gray-600 mb-5 leading-relaxed">
        AI is currently generating content for your job description. 
        If you proceed now, the generation will be interrupted and any 
        partial content may be lost.
      </p>

      <div className="flex justify-end gap-2">
        <button
          onClick={handleCancelAction}
          className="px-4 py-2 text-xs font-semibold rounded-full
                     border border-gray-300 text-gray-700
                      transition-colors"
        >
          Stay & Continue
        </button>

        <button
          onClick={handleProceedWithAction}
          className="px-4 py-2 text-xs font-semibold rounded-full
                     bg-gradient text-white
                     transition-colors"
        >
          Proceed Anyway
        </button>
      </div>
    </div>
  </div>
)}
     {showSubmitConfirmation && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
    <div className="bg-white rounded-lg shadow-xl w-[420px] p-5 animate-fadeIn">
      <div className="flex items-center gap-3 mb-3">
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-green-100">
          <Check className="w-6 h-6 text-green-600" />
        </div>
        <h3 className="text-sm font-semibold text-gray-800">
          Confirm Submission
        </h3>
      </div>

      <p className="text-xs text-gray-600 mb-5 leading-relaxed">
        Are you sure you want to save this AI-generated job description? 
       
      </p>

      <div className="flex justify-end gap-2">
        <button
          onClick={() => setShowSubmitConfirmation(false)}
          className="px-4 py-2 text-xs font-semibold rounded-full
                     border border-gray-300 text-gray-700
                     hover:bg-gray-50 transition-colors"
        >
          Cancel
        </button>

        <button
          onClick={() => {
            handleSaveAiAssist();
            setIsNewDescription(false);
            setShowSubmitConfirmation(false);
          }}
          className="px-4 py-2 text-xs font-semibold rounded-full
                     bg-gradient text-white
                     hover:opacity-90 transition-colors"
        >
           Save
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default JobDataDetailed;
